import {
  decodeJwtPayload,
  getStoredAccessToken,
  getStoredProfileCache,
} from './services/_core';

/**
 * Stable identity for permission-scoped management caches.
 * Prefer JWT subject/user id; fall back to profile cache; never use org here —
 * admin list APIs are intentional global+permission-filtered unless noted.
 */
export function getAuthQueryScope() {
  const payload = decodeJwtPayload(getStoredAccessToken());
  const fromJwt = String(
    payload?.uu_id || payload?.user_id || payload?.sub || payload?.email || payload?.preferred_username || ''
  )
    .trim()
    .toLowerCase();
  if (fromJwt) return fromJwt;

  const profile = getStoredProfileCache();
  const fromProfile = String(profile?.uu_id || profile?.email || '')
    .trim()
    .toLowerCase();
  return fromProfile || 'anonymous';
}

export function usersOrgsPageQueryKey(authScope = getAuthQueryScope()) {
  return ['users-orgs-page', authScope];
}

export function partnersPageQueryKey(authScope = getAuthQueryScope()) {
  return ['partners-page', authScope];
}

export function connectorsPageQueryKey(tab, authScope = getAuthQueryScope()) {
  return ['connectors-page', authScope, tab === 'network' ? 'network' : 'web'];
}

export function connectorsSitesQueryKey(authScope = getAuthQueryScope()) {
  return ['connectors-sites', authScope];
}

export function manageUsersListQueryKey(orgId, authScope = getAuthQueryScope()) {
  return ['manage-users', authScope, orgId || 'all'];
}

export function manageUsersOrgsQueryKey(authScope = getAuthQueryScope()) {
  return ['manage-users-orgs', authScope];
}

export function manageUsersSitesQueryKey(authScope = getAuthQueryScope()) {
  return ['manage-users-sites', authScope];
}

export function scopeSelectorOrganizationsQueryKey(authScope = getAuthQueryScope()) {
  return ['scope-selector', 'organizations', authScope];
}

export function scopeSelectorSitesQueryKey(selectedOrgId, authScope = getAuthQueryScope()) {
  return ['scope-selector', 'sites', authScope, String(selectedOrgId || 'all')];
}
